export default function parseChangelog(changelog) {
	const releases = {};

	let release;
	let items;

	for (const line of changelog.split("\n")) {
		const header = line.match(/^## (\d+\.\d+)\.\d+(-\S+)? \((\S+)\)$/);

		if (header) {
			const [, version, prerelease, date] = header;

			if (!releases[version]) {
				releases[version] = { version, features: new Set(), fixes: new Set() };
			}

			release = releases[version];
			items = null;

			if (prerelease) {
				if (!release.betaDate || date > release.betaDate) {
					release.betaDate = date;
				}
			} else if (!release.liveDate || date < release.liveDate) {
				release.liveDate = date;
			}
		} else if (line === "Features:") {
			items = release?.features;
		} else if (line === "Fixes:") {
			items = release?.fixes;
		} else if (line.startsWith("- ")) {
			items?.add(line.slice(2).replace(/\s*\(#\d+\)$/, ""));
		}
	}

	return Object.values(releases)
		.map(({ version, liveDate, betaDate, features, fixes }) => ({
			version,
			date: liveDate || betaDate,
			beta: !liveDate,
			features: [...features],
			fixes: [...fixes],
		}))
		.filter(({ features, fixes }) => features.length > 0 || fixes.length > 0)
		.sort((a, b) => b.version.localeCompare(a.version, undefined, { numeric: true }));
}
